/*
  Mixpanel Events
*/

/*
  Login
*/
export const MIXPANEL_USER_LOGIN = 'Login';

/*
  Storyboard
*/
export const MIXPANEL_CREATE_STORYBOARD = 'Storyboard Created';
export const MIXPANEL_CLONE_STORYBOARD = 'Storyboard Cloned';
export const MIXPANEL_PUBLISH_STORYBOARD = 'Storyboard Published';
export const MIXPANEL_OPEN_STORYBOARD = 'Storyboard Details Viewed';
export const MIXPANEL_CUSTOM_SCRIPT_ENABLED = 'Custom Scripts Enabled';
export const MIXPANEL_PAGE_VIEWED = "Page Viewed"
export const MIXPANEL_PASSWORD_ENABLED = 'Password Enabled';
export const MIXPANEL_FAV_ICON_ADDED = 'Fav Icon Added';
export const MIXPANEL_SITE_VERIFICATION_CONFIGURED = 'Site Verification Configured';
export const MIXPANEL_TRACKING_PIXEL_ADDED = 'Tracking Pixel Added';
export const MIXPANEL_REPORTS_DOWNLOADED = 'Reports Downloaded';
export const MIXPANEL_GATING_CONFIGURED = "Gating Configured";
export const MIXPANEL_STORYBOARD_IMPORTED = "Storyboard Imported";
export const MIXPANEL_PERSONALIZATION_LINK_GENERATED = 'Personalization Link Generated';


/*
  Brandkit
*/
export const MIXPANEL_BRANDKIT_CREATED = 'Brandkit Element Created';
export const MIXPANEL_BRANDKIT_PUBLISHED = 'Brandkit Element Published';
export const MIXPANEL_BRANDKIT_SHOW_ONLY_TOGGLED = 'Show Only Brand Widget Toggled';
export const MIXPANEL_WIDGET_ADDED = 'Widget Used on Editor';

/*
  Custom Form Fields
*/
export const MIXPANEL_FORM_FIELDS_CREATED = 'Custom Form Fields Created';
export const MIXPANEL_FORM_FIELDS_ADDED_TO_FORM = 'Custom Form Fields Added';
export const MIXPANEL_OTP_ENABLED = 'OTP Enabled';

/*
  Actions
*/
export const MIXPANEL_ONCLICK_GATING_ENABLED = 'On-click Gating Enabled';
export const MIXPANEL_PAGE_ACTION_ENABLED = 'Page as Action Enabled';

/*
  Editor
*/  
export const MIXPANEL_WIDGET_USED = 'Widget Used';
export const MIXPANEL_WIDGET_LAYER_DRAGGED = 'Widget Layer Dragged';
export const MIXPANEL_MOBILE_OPTIMIZATION_CLICKED = 'Mobile Optimization Clicked';
export const MIXPANEL_ASSET_UPLOADED = 'Asset Uploaded';
export const MIXPANEL_VARIABLE_SEARCH = 'Variable Search';
export const MIXPANEL_GATING_CONFIGURED_FROM_EDITOR = 'Gating Configured from Editor'

/*
  Alias
*/
export const MIXPANEL_ASSET_ALIAS_CHANGED = "Asset Alias Changed";


/*
Page Viewed Events
*/

export const MIXPANEL_PAGE_VIEWED_STORYBOARD_SETTINGS = "Storyboard Settings";
export const MIXPANEL_PAGE_VIEWED_PREVIEW = "Preview";
export const MIXPANEL_PAGE_VIEWED_TEMPLATES = "Templates";
export const MIXPANEL_PAGE_VIEWED_EDITOR = "Editor";
export const MIXPANEL_PAGE_VIEWED_REPORTS = "Reports";
export const MIXPANEL_PAGE_VIEWED_LEAD_REPORTS = "Lead Reports";
export const MIXPANEL_PAGE_VIEWED_LEAD_DETAIL_VIEWED = "Lead Detail View";
export const MIXPANEL_PAGE_VIEWED_SITE_PERFORMANCE = "Site Performance";
export const MIXPANEL_PAGE_VIEWED_STORYBOARD_USER_MANAGEMENT = "Storyboard User Management";
export const MIXPANEL_PAGE_VIEWED_CONTENT_MANAGER = "Content Manager";
export const MIXPANEL_PAGE_VIEWED_WORKSPACE_USER_MANAGEMENT = "Workspace User Management";
export const MIXPANEL_PAGE_VIEWED_INTEGRATIONS = "Integrations";
export const MIXPANEL_PAGE_VIEWED_CUSTOM_FORM_FIELDS = "Custom Form Fields";
export const MIXPANEL_PAGE_VIEWED_FORM_INTEGRATIONS = "Form Integrations";
export const MIXPANEL_PAGE_VIEWED_FORM_BRANDKIT = "Brand kit";
export const MIXPANEL_PAGE_VIEWED_JOURNEY = "Journey";
export const MIXPANEL_PAGE_VIEWED_JOURNEY_REPORTS = "Journey Reports";
export const MIXPANEL_PAGE_VIEWED_WORKSPACE_REPORTS = "Workspace Reports";
export const MIXPANEL_PAGE_VIEWED_ABM_AND_DISTRIBUTION = "ABM & Distribution";
export const MIXPANEL_PAGE_VIEWED_MY_STORYBOARD = "My Storyboards";

/*
  Journey Events
*/
export const JOURNEY_CREATED = "Journey Created";
export const JOURNEY_ENABLED = "Journey Enabled";

/*
  Storyboard
*/
export const MIXPANEL_DISTRIBUTION_CLICKED = "Distribution Clicked";

/*
  Workspace
*/
export const MIXPANEL_USER_MANAGEMENT_SEARCH = "User Management Search Used";

